import React, { SVGProps } from 'react'

export const EyeQuestionSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={65}
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M31.998 32.022a5.332 5.332 0 1 0 0-10.663 5.332 5.332 0 1 0 0 10.663Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.665 27.295c0 13.657 8.753 23.94 17.893 32.886 1.568 1.535 4.154 1.566 5.844.166 6.329-5.242 18.93-16.037 18.93-33.052 0-12.111-9.552-21.93-21.334-21.93s-21.333 9.819-21.333 21.93Zm5.333-.604c4.8-5.717 17.92-13.721 32 0-5.333 6.352-19.2 15.245-32 0Z"
      clipRule="evenodd"
    />
  </svg>
)
export default EyeQuestionSvg
